// extracted by mini-css-extract-plugin
var _1 = "VersionChangesWall-module__animatedBackground--wAZSz";
var _2 = "36px";
var _3 = "VersionChangesWall-module__container--a_NRQ";
var _4 = "VersionChangesWall-module__item--iNKyl";
var _5 = "VersionChangesWall-module__wallItems--ieRtw";
export { _1 as "animatedBackground", _2 as "authorCardGap", _3 as "container", _4 as "item", _5 as "wallItems" }
